import { createContext, useContext } from "react";
import { useDynamicRate } from "../hooks/dynamic-rates/useDynamicRate";

const Context = createContext();

export const DynamicRateProvider = ({ children }) => {
    return (
        <Context.Provider value={useDynamicRate()}>{children}</Context.Provider>
    )
};

export const useDynamicRateContext = () => useContext(Context);